__webpack_require__.p = "/hospital-portal/";